<template>
  <!-- 根元素 -->
  <div class="my-component">
    <div id="J_prismPlayer" style="z-index: 1;width:100vw;"></div>
  </div>
</template>

<script>
import loginService from '../../plugin/extendFn/loginService';
export default {
    data() {
      return {
        chimee: null,
        ra_wxUser: null
      }

    },
  // 组件的 JavaScript 逻辑
 async  mounted() {
    this.ra_wxUser = await loginService.getLoginUser();

    this.$nextTick(() => {
      this.chimeeConfig();
    });
    
   
      
  },
  methods:  {
    chimeeConfig() {
      this.chimee = new Aliplayer({
      id: "J_prismPlayer",
      width: "100%",
      source: 'https://www.w3school.com.cn/example/html5/mov_bbb.mp4',
      // source: 'http://ralive.oss-cn-shanghai.aliyuncs.com/record/liveapp/1598/2025-01-23-13-54-48_2025-01-23-15-04-00.mp4',
      // isLive: this.$route.query.type == 'video' ? false : this.videoinfo.lState == 3 ? false : true,
      isLive: false, //直播全屏切换小屏的问题
      playsinline: true, //H5是否内置播放
      useH5Prism: true, //强制H5播放器

      rePlay: false,
      WebView: "allowsInlineMediaPlayback",
      preload: true, //播放器自动加载
      controlBarVisibility: "hover", //控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
      allowsInlineMediaPlayback: true,
      autoplay: false,
      // useH5Prism:true,//使用自适应播放器，然后设置useH5Prism属性为true
      enableSystemMenu: true, //是否允许系统右键菜单显示，默认为false。
      // autoPlayDelay:2,//延迟播放时间，单位为秒。
      loadDataTimeout: 5, // 缓冲多长时间后，提示用户切换低清晰度，默认：20秒。
      showBarTime: "10000", //控制栏自动隐藏时间（ms）
      //支持播放地址播放,此播放优先级最高
      disableSeek: false, //禁用进度条的Seek，默认为false，仅Flash支持
      skinLayout: [
        {
          name: "bigPlayButton",
          align: "blabs",
          x: 30,
          y: 80,
        },
        {
          name: "H5Loading",
          align: "cc",
        },
        {
          name: "errorDisplay",
          align: "tlabs",
          x: 0,
          y: 0,
        },
        {
          name: "infoDisplay",
        },
        {
          name: "tooltip",
          align: "blabs",
          x: 0,
          y: 56,
        },
        {
          name: "thumbnail",
        },
        {
          name: "controlBar",
          align: "blabs",
          x: 0,
          y: 0,
          children: [
            {
              name: "progress",
              align: "blabs",
              x: 0,
              y: 44,
            },
            {
              name: "playButton",
              align: "tl",
              x: 15,
              y: 12,
            },
            {
              name: "timeDisplay",
              align: "tl",
              x: 10,
              y: 7,
            },
            {
              name: "fullScreenButton",
              align: "tr",
              x: 10,
              y: 12,
            },
            {
              name: "subtitle",
              align: "tr",
              x: 15,
              y: 12,
            },
            {
              name: "volume",
              align: "tr",
              x: 5,
              y: 10,
            },
          ],
        },
      ],
    },
    () => {
          if (true) {
            console.log('播放器创建成功');
            // 创建水印元素
            var watermark = document.createElement('div');
            watermark.textContent = '水印文本'; // 水印文本
            watermark.style.position = 'absolute';
            watermark.style.top = '10px';
            watermark.style.right = '10px';
            watermark.style.color = 'black';
            watermark.style.opacity = '0.5'; // 设置透明度为 50%
            watermark.style.fontSize = '12px';
            watermark.style.zIndex = 999; // 确保水印显示在最上层

            // 获取播放器容器
            var playerContainer = document.getElementById('J_prismPlayer');
            playerContainer.appendChild(watermark);

            // 初始化水印移动参数
            let xSpeed = 1; // x 轴移动速度
            let ySpeed = 1; // y 轴移动速度
            let currentX = parseInt(watermark.style.left) || 0;
            let currentY = parseInt(watermark.style.top) || 0;

            // 定时更新水印位置
            let moveInterval;
            function startMoving() {
              moveInterval = setInterval(() => {
                // 获取播放器容器的宽度和高度
                const containerWidth = playerContainer.offsetWidth;
                const containerHeight = playerContainer.offsetHeight;
                // 获取水印元素的宽度和高度
                const watermarkWidth = watermark.offsetWidth;
                const watermarkHeight = watermark.offsetHeight;

                // 更新位置
                currentX += xSpeed;
                currentY += ySpeed;

                // 检查边界并改变方向
                if (currentX + watermarkWidth > containerWidth || currentX < 0) {
                  xSpeed = -xSpeed;
                }
                if (currentY + watermarkHeight > containerHeight || currentY < 0) {
                  ySpeed = -ySpeed;
                }

                // 更新水印的位置
                watermark.style.left = currentX + 'px';
                watermark.style.top = currentY + 'px';
              }, 50);
            }

            function stopMoving() {
              clearInterval(moveInterval);
            }

            // 随机生成 15 - 20 秒的展示时间
            const showTime = Math.floor(Math.random() * (20 - 15 + 1) + 15) * 1000;
            const hideTime = 30 * 1000;

            function showWatermark() {
              watermark.style.display = 'block';
              startMoving();
              setTimeout(() => {
                hideWatermark();
              }, showTime);
            }

            function hideWatermark() {
              watermark.style.display = 'none';
              stopMoving();
              setTimeout(() => {
                showWatermark();
              }, hideTime);
            }

            // 开始循环
            showWatermark();
            // // 处理全屏事件，确保全屏时水印也正常显示
          this.chimee.on('fullscreenchange',  ()=> {
            if (this.chimee.isFullscreen()) {
                // 全屏时调整水印样式
                watermark.style.position = 'fixed';
            } else {
                // 退出全屏时恢复水印样式
                watermark.style.position = 'absolute';
            }
          })

          }



          
        }
    );
    }

  }
  
  

  
}
</script>

<style scoped>
/* 组件的样式 */
#J_prismPlayer {
  width: 500px;
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/container/demovideo.vue